import React from 'react';
import { Box } from 'grommet';
import CourseCard from 'modules/course/CourseCard';
import { courseViewModel$ } from 'modules/course/course$';
import { connect } from 'rxbeach/react';
import { Course } from 'types';
import useResponsive from 'hooks/useResponsive';

const LatestCourses = ({ visibleCourses }: { visibleCourses: Course[] }) => {
  const { isMobile } = useResponsive();
  return (
    <Box
      direction={isMobile ? 'column' : 'row'}
      align="center"
      justify="center"
      gap="medium"
      pad="medium"
      margin="small"
    >
      {visibleCourses.slice(0, 4).map((course) => (
        <CourseCard key={course.id} {...course} />
      ))}
    </Box>
  );
};

export default connect(LatestCourses, courseViewModel$);
